import * as z from 'zod';

export const imageSearchResultSchema = z.object({
  sourceName: z.string(),
  sourceUrl: z.string(),
  downloadUrl: z.string(),
  previewUrl: z.string(),
  imageName: z.string().nullable().optional(),
  creator: z.string().nullable().optional(),
  creatorUrl: z.string().nullable().optional(),
  caption: z.string().optional(),
});
export const imageSearchResultArraySchema = z.array(imageSearchResultSchema);

export type ImageSearchResult = z.infer<typeof imageSearchResultSchema>;
